const features = [
  {
    icon: 'ri-shield-check-line',
    title: '完全免费 · 无需注册',
    desc: '悟空影视坚持零门槛服务，无需注册账号、无需绑定手机、无需付费订阅。打开网页即可立即观看海量高清内容，真正做到零成本追剧观影。',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载 · 流畅不缓冲',
    desc: '采用全球 CDN 加速节点，智能匹配最优播放线路。无论是 1080P 高清还是 4K 超清，都能实现即点即播、流畅不缓冲的极致观影体验。',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源 · 每日更新',
    desc: '内容库覆盖电影、电视剧、综艺、动漫、纪录片全品类，每日实时更新 200+ 部最新资源。热门剧集同步追更，经典老片随时回顾，满足多元观影需求。',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            为什么选择悟空影视
          </h2>
          <p className="text-sm text-foreground-500">三大核心优势，重新定义免费观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-xl ${feat.color} mb-4`}>
                <i className={`${feat.icon} text-xl`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}